import React, { Component } from 'react';

class Resume extends Component {
    state = {  }
    render() { 
        return ( 
            <div className='main-page'>
                <h1>Resume page</h1>
            </div>
         );
    }
};
 
export default Resume;


// WEBPACK FOOTER //
// ./src/components/Resume.js